module.exports = require("./kde.d.ts");